module.exports = __webpack_public_path__ + "static/img/putcontent_7.ba8a491.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/ad/putcontent_7.png
// module id = 7/Ii
// module chunks = 1